import { Api } from "@/utils/http/types";
import { RequestEnum } from "@/enums/httpEnum";

const TranslateApis = {
  translate: new Api({
    url: "https://translate.googleapis.com/translate_a/single",
    desc: "谷歌翻译接口",
    method: RequestEnum.GET
  }),
  langDetect: new Api({
    url: "https://fanyi.baidu.com/langdetect",
    desc: "百度语言检测接口",
    method: RequestEnum.POST
  })
};

export default TranslateApis;
